import { Stack } from '@mui/material';
import FormDialog from '../form/form-dialog';
import FormInput from '../form/form-input';
import http from '../utils/http';
import useForm from '../hooks/useForm'


import { isEmpty } from 'lodash';
import React from 'react';

const ApplicationURIAddModal = (props) => {
    const {
        state,
        onChange,
        onChangeBulk,
        onInvalidForm,
        onResetFormErrors
    } = useForm({
        debug: true,
        initialState: {
            applicationURIAddName: '',
            applicationURIAddURI: ''
        }
    });
    const {
        config,
        isOpen,
        onChangeBulk: parentOnChangeBulk,
        environmentId
    } = props;
    return (
        <FormDialog
            dialogTitle={'Add New Application URI'}
            dialogSubHeading={'Add a new application URI that the API/UI will be aware of in its context'}
            handleClose={() => {
                onResetFormErrors();
                onChangeBulk({
                    applicationURIAddName: '',
                    applicationURIAddURI: ''
                })
                parentOnChangeBulk({ applicationURIAddModalIsOpen: false })
            }}
            handleSubmit={async () => {
                const errors = {};
                if (!state.values.applicationURIAddName) errors.applicationURIAddName = 'You must supply a URI name (i.e. key) for the property key';
                if (!state.values.applicationURIAddURI) errors.applicationURIAddURI = 'You must supply a URI for the property value';
                if (!isEmpty(errors)) return onInvalidForm(errors);

                const application = await http.post({
                    uriKey: state.values.applicationURIAddName,
                    uriValue: state.values.applicationURIAddURI,
                }, `${config.uri.base}/environment/${environmentId}/uri`);

                onChangeBulk({
                    applicationURIAddURI: '',
                    applicationURIAddName: '',
                });

                parentOnChangeBulk({
                    applicationURIAddModalIsOpen: false,
                    application: application,
                    environments: application.environments,
                });
            }}
            isOpen={isOpen}
        >
            <Stack direction='column'>
                <FormInput
                    label='Name (or key) of URI prop'
                    path='applicationURIAddName'
                    value={state.values.applicationURIAddName}
                    error={state.errors.applicationURIAddName}
                    onChange={(value, path) => {
                        value = value.toLowerCase();
                        value = value.replace(/\s/g, '')
                        onChange(value, path);
                    }}
                />
                <FormInput
                    label='URI'
                    path='applicationURIAddURI'
                    value={state.values.applicationURIAddURI}
                    error={state.errors.applicationURIAddURI}
                    onChange={onChange}
                />
            </Stack>
        </FormDialog>
    );
}

export default ApplicationURIAddModal;
